import { Stack, Tooltip, Typography } from '@mui/material';
import SportsBarIcon from '@mui/icons-material/SportsBar';
import { useTranslation } from 'react-i18next';
import { bggRatingValue } from './gameFormat';

const sizeConfig = {
  tiny: {
    icon: 12,
    gap: 0.12,
    text: '0.62rem',
  },
  small: {
    icon: 15,
    gap: 0.2,
    text: '0.72rem',
  },
  medium: {
    icon: 18,
    gap: 0.25,
    text: '0.82rem',
  },
};

const BggRatingMugs = ({ game, size = 'small', showValue = true, sx }) => {
  const { t } = useTranslation();
  const rating = bggRatingValue(game);

  if (!rating) return null;

  const config = sizeConfig[size] || sizeConfig.small;
  const filledMugs = Math.max(1, Math.min(5, Math.round(rating / 2)));
  const label = t('games.rating.bggScore', {
    value: rating.toFixed(1),
  });

  return (
    <Tooltip title={label}>
      <Stack
        direction="row"
        spacing={config.gap}
        alignItems="center"
        aria-label={label}
        sx={{
          color: 'secondary.main',
          textShadow: '0 2px 8px rgba(0, 0, 0, 0.65)',
          ...sx,
        }}
      >
        {Array.from({ length: 5 }, (_, index) => (
          <SportsBarIcon
            key={index}
            sx={{
              fontSize: config.icon,
              opacity: index < filledMugs ? 1 : 0.28,
              filter: index < filledMugs ? 'drop-shadow(0 1px 2px rgba(0,0,0,0.45))' : 'none',
            }}
          />
        ))}
        {showValue ? (
          <Typography
            component="span"
            sx={{
              pl: 0.25,
              color: 'inherit',
              fontSize: config.text,
              fontWeight: 800,
              lineHeight: 1,
            }}
          >
            {rating.toFixed(1)}
          </Typography>
        ) : null}
      </Stack>
    </Tooltip>
  );
};

export default BggRatingMugs;
